import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { useState } from 'react';
import ChildrenActiveOverAge12Report from '../component/report/children-active-over-age-12';
import ChildrenInactiveReport from '../component/report/children-inactive';
import Parents01Report from '../component/report/parents-01';
import Parents02Report from '../component/report/parents-02';
import ParentsNoEmailReport from '../component/report/parents-no-email';
import StateReport1 from '../component/report/state-report-1';
import StateReport10 from '../component/report/state-report-10';
import StateReport11 from '../component/report/state-report-11';
import StateReport12 from '../component/report/state-report-12';
import StateReport13 from '../component/report/state-report-13';
import StateReport14 from '../component/report/state-report-14';
import StateReport2 from '../component/report/state-report-2';
import StateReport3 from '../component/report/state-report-3';
import StateReport4 from '../component/report/state-report-4';
import StateReport5 from '../component/report/state-report-5';
import StateReport6 from '../component/report/state-report-6';
import StateReport7 from '../component/report/state-report-7';
import StateReport8 from '../component/report/state-report-8';
import StateReport9 from '../component/report/state-report-9';

function ReportsPage() {
    const [reports] = useState([...REPORTS]);
    const [selectedReport, setSelectedReport] = useState('');

    return (
        <Card title="Reports Dashboard" className="pageCard">
            <div className="card flex flex-wrap gap-3 p-fluid">
                <div className="flex-auto">
                    <label htmlFor="selectReport" className="font-bold block mb-2">
                        Select Report
                    </label>

                    <Dropdown
                        value={selectedReport}
                        name="selectReport"
                        showClear
                        onChange={(e) => setSelectedReport(e.value)}
                        options={reports}
                        optionLabel="itemName"
                        optionValue="_id"
                        placeholder="Select a Report"
                    />
                </div>
            </div>

            {selectedReport !== 'a' ? null : <ParentsNoEmailReport />}

            {selectedReport !== 'b' ? null : <ChildrenInactiveReport />}

            {selectedReport !== 'c' ? null : <ChildrenActiveOverAge12Report />}

            {selectedReport !== 'd' ? null : <StateReport1 />}

            {selectedReport !== 'e' ? null : <StateReport2 />}

            {selectedReport !== 'f' ? null : <StateReport3 />}

            {selectedReport !== 'g' ? null : <StateReport4 />}

            {selectedReport !== 'h' ? null : <StateReport5 />}

            {selectedReport !== 'i' ? null : <StateReport6 />}

            {selectedReport !== 'j' ? null : <StateReport7 />}

            {selectedReport !== 'k' ? null : <StateReport8 />}

            {selectedReport !== 'l' ? null : <StateReport9 />}

            {selectedReport !== 'm' ? null : <StateReport10 />}

            {selectedReport !== 'n' ? null : <StateReport11 />}

            {selectedReport !== 'o' ? null : <StateReport12 />}

            {selectedReport !== 'p' ? null : <StateReport13 />}

            {selectedReport !== 'q' ? null : <StateReport14 />}

            {selectedReport !== 'r' ? null : <Parents01Report />}

            {selectedReport !== 's' ? null : <Parents02Report />}
        </Card>
    );
}

const REPORTS = [
    {
        _id: 'a',
        itemName: 'Parents without email addresses'
    },
    {
        _id: 'b',
        itemName: 'Inactive Children'
    },
    {
        _id: 'c',
        itemName: 'Active Children Over Age 12'
    },
    {
        _id: 'd',
        itemName: 'State Report 1 - # Famlies Provided Referrals'
    },
    {
        _id: 'e',
        itemName: 'State Report 2 - # Famlies Received Follow-up/Enhanced Referral'
    },
    {
        _id: 'f',
        itemName: 'State Report 3 - # Programs Received Referrals to Comprehensive Services'
    },
    {
        _id: 'g',
        itemName: 'State Report 4 - # Kindergarten Transition Activities Provided'
    },
    {
        _id: 'h',
        itemName:
            'State Report 5 - # Families/Children Received Info about Kindergarten Registration'
    },
    {
        _id: 'i',
        itemName: 'State Report 6 - # of Parent Eductaion Trainings Offered'
    },
    {
        _id: 'j',
        itemName: 'State Report 7 - # of Playgroups Offered'
    },
    {
        _id: 'k',
        itemName: 'State Report 8 - # of Outreace Events Offered'
    },
    {
        _id: 'l',
        itemName: 'State Report 9 - # of Families that Received a Link to Complete ASQ Online'
    },
    {
        _id: 'm',
        itemName: 'State Report 10 - # of Families that Received a Hardcopy ASQ to Complete'
    },
    {
        _id: 'n',
        itemName: 'State Report 11 - # of Families who were Provided Follow-up based on ASQ Results'
    },
    {
        _id: 'o',
        itemName: 'State Report 12 - # of Screenings COMPLETED AND ENTERED ONLINE'
    },
    {
        _id: 'p',
        itemName:
            'State Report 13 - # of Screenings COMPLETED using ONLY PAPER - NOT ENTERED ONLINE'
    },
    {
        _id: 'q',
        itemName: 'State Report 14 - # and Types of Spaces Available Across Service Area'
    },
    {
        _id: 'r',
        itemName: 'Parents Report 01 - Filter by Date Added'
    },
    {
        _id: 's',
        itemName: 'Parents Report 02 - Filter by Service Date (Individual or Group)'
    }
];

export default ReportsPage;
